import type { MultiLang } from '../../config';
import Functions from '../../functions';

export interface CreditsPageData {
    pid: number;
    title: string;
    content: string;
    lastupdate: number;
}

export interface CreditsData {
    organization: string;
    pages: CreditsPageData[];
}

export interface CreditsMenu {
    title: string;
    link: string;
}

class CreditsUtils {
    private data: CreditsData | null = null;

    init(json: CreditsData): void {
        this.data = json;
    }

    private get credits(): CreditsData {
        if (this.data === null) {
            throw new Error('credits data was read before loadSiteData() completed');
        }
        return this.data;
    }

    getTitle(lang: MultiLang): string {
        return Functions.mlang('[en]Site Information[/en][ja]サイト情報[/ja]', lang);
    }

    getIndexUrl(): string {
        return '/credits';
    }

    getPageUrl(pageId: number): string {
        return `${this.getIndexUrl()}/${pageId}`;
    }

    getMenu(): CreditsMenu[] {
        const menu: CreditsMenu[] = [];
        this.credits.pages.forEach((page) => {
            menu.push({ title: page.title, link: this.getPageUrl(page.pid) });
        });
        menu.push({ title: this.getAboutUsTitle(), link: this.getIndexUrl() });
        return menu;
    }

    getPage(pageId: number): CreditsPageData | null {
        const page = this.credits.pages.find((page) => {
            return page.pid === pageId;
        });
        if (typeof page === 'undefined') {
            return null;
        }
        return page;
    }

    countPages(): number {
        return this.credits.pages.length;
    }

    getAboutUsTitle(): string {
        return 'About Us';
    }

    getAboutUsContent(): string {
        return this.credits.organization;
    }
}

export default new CreditsUtils();
